import React, { createContext, useCallback, useEffect, useState } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Api, Slice
import { effciencyApi } from "../../../../app/services/efficiencyApi.js";
import { updateSelectedApp } from "../../../../Modules/configuration/HomeSlice.js";
import { cloudAccountList, getAccountIdList,getCSPList, getEnvironmentList } from "../cmdb-overview/appConfigSlice.js";

// Components
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
import DetailTable from "../../../../app/common-components/DetailTable/Index.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import DrillDownOffCanvas from "../../../../app/common-components/DrillDown/DrillDownOffCanvas.jsx";
import EmptyDrillDownThree from "../../../../app/common-components/DrillDown/EmptyDrillDownThree.jsx";
import Input from "../../../../app/common-components/form/input.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData.jsx";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice.js";
;


// 3rd Party Libraries
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { FiEdit, FiTrash2 } from "react-icons/fi";

// Helpers
import { convertEpochToDate, useCommonAlert } from "../../../../app/utilities/helpers.js";

// styles
import "../styles.scss";


export const ProjectContext = createContext();

const AccountIds = () => {
  const dispatch = useDispatch();
  const { userName } = useSelector((state) => state.common.loggedUser);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const {
    cloudAccountListData,
    cloudAccountListLoading,
    getCSPListData,
    getAccountIdListData,
    EnvironmentData,
  } = useSelector((state) => state.appConfig);
  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");
  const calculatedPageCount = cloudAccountListData?.totalCount
    ? Math.ceil(cloudAccountListData?.totalCount / pageLimit)
    : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
  const [showCsp, setShowCsp] = useState("");
  const [getId, setGetId] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [newArray, setnewArray] = useState([]);

  const [accountName, setAccountName] = useState("");
  const [environment, setEnvironment] = useState("");
  const [environmentData, setEnvironmentData] = useState("");
  const [AccountCreatedDate, setAccountCreatedDate] = useState("");
  const [accdateError, setAccdateError] = useState(false);
  const [accdateErrorMessage, setAccdateErrorMessage] = useState("");
  // const [projectState, setProjectState] = useState({
  const [cloudDeleteLoad, setCloudDeleteLoad] = useState(false);
  const [state, setState] = useState({
    page: 0,
    limit: 10,
    tableData: [],
    count: 0,
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    deleteModalOpen: false,
    loadPage: false,
    modalOpen: false,
    loading: false,
    deleteId: "",
    cspTableData: [],
    cspListData: [],
    AccountIdError: false,
    CSPError: false,
    CSPErrorMessage: "",
    addBodyAccount: false,
    conformationPop: false,
    InfoBody: false,
    detailData: [],
    EnvironmentError: false,
    EnvironmentErrorMessage: "",
    AccountNameError: false,
    AccountNameErrorMessage: "",
  });
  const serverListData = cloudAccountListData?.data
    ? cloudAccountListData?.data
    : [];
  const { state: locationState } = useLocation();

  const payloadid = locationState?.id;
  useEffect(() => {
    if (locationState && locationState.appLabel) {
      const homeNavApp = {
        label: `${locationState.appLabel}[${locationState.appCode}]`,
        value: locationState.appCode,
        id: locationState.id,
      };
      dispatch(updateSelectedApp(homeNavApp));
    } else {
      dispatch(updateSelectedApp({}));
    }
  }, [dispatch]);
  if (!payloadid) {
    window.location.replace("/efficiency/appConfig");
  }

  const [getCspListPagination] = effciencyApi.useGetCspListPaginationMutation();
  const [getCspSaveOrUpdate] = effciencyApi.useGetCspSaveOrUpdateMutation();
  const [getCspDelete] = effciencyApi.useGetCspDeleteMutation();
  const [getCspAccountList] = effciencyApi.useGetCspAccountListMutation();

  const [currentAction, setCurrentAction] = useState("");

  const payload = {
    keyword: searchKey,
  };

  const fetchData = async () => {
    try {
      getCspListPagination({ payloadid, page: state.page, limit: state.limit })
        .unwrap()
        .then(() => {
          setState((state) => ({
            ...state,
            // cspTableData: cspDataList,
          }));
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getAccountIDOption = () => {
    getCspAccountList()
      .unwrap()
      .then((userListResp) => {
        setState((state) => ({
          ...state,
          cspListData: userListResp.map((user) => ({
            label: user.accountId,
            value: user.accountId,
          })),
        }));
      });
  };
  useEffect(() => {
    getAccountIDOption();
  }, []);

  useEffect(() => {
    fetchData();
  }, [state.page, state.limit]);

  const DateToEpochConverter = (dateString) => {
    const dateObject = new Date(dateString);
    const epochValue = dateObject.getTime();

    return epochValue;
  };

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = date.toISOString().split("T")[0];
    return formattedDate;
  }

  const modalBodyInfo = () => {
    const data = state.detailData.original;
    const detailsTableData = [
      { header: "Added By", values: data?.createdBy ? data.createdBy : "-" },
      {
        header: "Added On",
        values: data?.addedOn ? convertEpochToDate(data.addedOn) : "-",
      },
      { header: "Updated By", values: data?.updatedBy ? data.updatedBy : "-" },
      {
        header: "Updated On",
        values: data?.updateDate ? convertEpochToDate(data.updateDate) : "-",
      },
    ];
    return (
      <>
        <h4 className="schedule-tool">{"Details"}</h4>
        <div>
          <DetailTable data={detailsTableData} />
        </div>
      </>
    );
  };
  const InfomodalCancelAccount = () => {
    setState({
      ...state,
      InfoBody: false,
      detailData: [],
    });
  };

  const columns = [
    {
      Header: "Cloud Service Providers",
      accessor: "csp",
      disableSortBy: true,
    },
    {
      Header: "Account ID",
      accessor: "accountId",
      disableSortBy: true,
    },
    {
      Header: "Account Name",
      accessor: "accountName",
      disableSortBy: true,
    },
    {
      Header: "Environment",
      accessor: "environment",
      disableSortBy: true,
    },
    {
      Header: "Account Created Date",
      accessor: "accountCreatedDate",
      disableSortBy: true,
      Cell: ({ value }) => {
        return <>{value ? convertEpochToDate(value) : "-"}</>;
      },
    },
    {
      Header: "Last Imported On",
      colSpan: 3,
      thClassName: "text-center noSort",

      disableSortBy: true,
      columns: [
        {
          Header: "Security Hub Findings",
          accessor: "lastScannedDateForSecurityHub",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? convertEpochToDate(value) : "-"}</>;
          },
        },
        {
          Header: "Cloud Cost Insights",
          accessor: "lastScannedDateForBillingCost",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? convertEpochToDate(value) : "-"}</>;
          },
        },
        {
          Header: "TRMG",
          accessor: "trmg",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? convertEpochToDate(value) : "-"}</>;
          },
        },
      ],
    },
    {
      Header: "Details",
      className: "text-center noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "text-center",
      Cell: ({ row }) => {
        return (
          <a
            title="Details"
            onClick={() => {
              setState({
                ...state,
                InfoBody: true,
                detailData: row,
              });
            }}
          >
            <FaInfoCircle
              className="faInfoCircleStyle"
              size={15}
              data-bs-toggle="tooltip"
              data-bs-placement="left"
            />
          </a>
        );
      },
    },
    {
      Header: "Action",
      accessor: "Action",
      tdClassName: "text-center",
      className: "text-center",
      thClassName: "text-center",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div className="actionsBtn d-flex justify-content-center">
          {" "}
          <div className="actcol cloudAccountsManagement">
            <a title="Edit">
              <FiEdit
                className="edit-icon disabled-link"
                data-testid="editIcon"
                onClick={() => openserver("edit", row.original.id)}
                size={20}
              />
            </a>
          </div>
          <div className="actcol cloudAccountsManagement">
            <FiTrash2
              title="Delete"
              className="iconStyleActions"
              onClick={() => {
                setState((state) => ({
                  ...state,
                  modalOpen: true,
                  deleteId: row.original.id,
                }));
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  const getAccountInfo = () => {
    const appCode = locationState?.appCode;
    dispatch(
      cloudAccountList({
        appliaction: appCode,
        pageNumber: pageNo,
        itemsPerPage: pageLimit,
        payload,
      })
    );
  };

  useEffect(() => {
    getAccountInfo();
  }, [pageNo, pageLimit, searchKey]);

  const handleSearch = (name, searchString) => {
    if (name == "AccountId") {
      setSelectedValue(searchString);
    } else if (name == "CSP") {
      setShowCsp(searchString);
    }
  };
  const handleOnChange = (name, selected) => {
    setState((state) => ({
      ...state,
      [`${name}Error`]: false,
      [`${name}ErrorMessage`]: "",
      conformationPop: true,
    }));
    if (Array.isArray(selected) && selected.length > 0) {
      if (name == "CSP") {
        dispatch(getAccountIdList(selected[0].value));
        setShowCsp(selected[0].value);
      } else if (name == "AccountId") {
        setSelectedValue(selected[0].value);
      } else if (name == "Environment") {
        setEnvironment(selected[0].value);
      }
    } else {
      if (name == "CSP") {
        setShowCsp(selected);
      } else if (name == "AccountId") {
        setSelectedValue(selected);
      } else if (name == "Environment") {
        setEnvironment(selected);
      } else if (name === "AccountName") {
        setAccountName(selected);
      }
    }
  };

  const clickbtn = () => {
    clearValidation();
    dispatch(getCSPList());
    dispatch(getEnvironmentList());
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
    return openserver("add", 0);
  };

  const btnData = [
    {
      text: "Map New",
      function: clickbtn,
      className: "solid-btn ",
    },
  ];

  const handleSaveAdd = () => {
    const validation = validateForm();
    if (validation) {
      const payload = {
        accountId: selectedValue.value,
        accountName: accountName,
        environment: environment.value,
        accountCreatedDate: DateToEpochConverter(AccountCreatedDate),
        csp: showCsp.value,
        createBy: "",
        createdDt: "",
        id: 0,
        updateBy: "",
        userCount: "",
        updateDt: "",
      };

      try {
        getCspSaveOrUpdate({ payloadid, userName, payload }).then((response) => {
          const res = response?.data || {};
          const { statusCodeValue, body } = res;

          if (statusCodeValue === 200) {
            addserverclose();
            getAccountInfo();
            callCommonAlert("success", body || "CSP created successfully");
            hideCommonAlert();
            setState((prev) => ({ ...prev, modalOpen: false }));
            dispatch(
              setIsOffCanvasOpen({
                isDrilldownOpen: false,
                isDropDownhide: false,
              })
            );
          } else if (statusCodeValue === 400) {
            getAccountInfo();
            callCommonAlert("error", body || "CSP Account already exists!");
            hideCommonAlert();
            setState((prev) => ({ ...prev, modalOpen: false }));
          } else {
            // Handle unexpected cases
            callCommonAlert("error", body || "Something went wrong!");
            hideCommonAlert();
          }
        });
      } catch (error) {
        callCommonAlert("error", "Something went wrong. Please try again.");
        hideCommonAlert();
        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
      }
    }
  };

  const deleteId = () => {
    getCspDelete({ id: state.deleteId, userName: userName })
      .unwrap(setCloudDeleteLoad(true))
      .then(({ statusCodeValue, body }) => {
        setCloudDeleteLoad(false);

        const isSuccess = statusCodeValue === 200;
        const message = body || (isSuccess
          ? "Cloud Account deleted successfully"
          : "Something went wrong");

        if (isSuccess) {
          getAccountInfo();
        }

        callCommonAlert(isSuccess ? "success" : "error", message);
        hideCommonAlert();

        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
        setpageNo(0);
      })
      .catch((error) => {
        setCloudDeleteLoad(false);
        callCommonAlert("error", "Failed to delete cloud account");
        console.error("Delete operation failed:", error);
      });
  };

  const openserver = async (action, id) => {
    clearValidation();
    getAccountIDOption();
    if (action == "edit") {
      dispatch(getEnvironmentList());
      const filteredServers = serverListData
        .map((cspData) => ({
          csp: cspData.csp,
          accountId: cspData.accountId,
          accountName: cspData.accountName,
          environment: cspData.environment,
          accountCreated: cspData.accountCreated,
          accountCreatedDate: cspData.accountCreatedDate,
          addedOn: cspData.addedOn,
          id: cspData.id,
        }))
        .filter((cspData) => cspData.id === id);
      setShowCsp(
        filteredServers.map((data) => ({
          label: data.csp,
          value: data.csp,
        }))
      );
      setSelectedValue(
        filteredServers.map((data) => ({
          label: data.accountId,
          value: data.accountId,
        }))
      );
      setAccountCreatedDate(
        formatTimestamp(
          Number(
            filteredServers.map((data) => data.accountCreatedDate).join(",")
          )
        )
      );
      setAccountName(filteredServers.map((data) => data.accountName).join(","));
      setEnvironment(
        filteredServers.map((data) => ({
          label: data.environment,
          value: data.environment,
        }))
      );
      setGetId(filteredServers.map((data) => data.id).join(","));
      setCurrentAction("edit");
    } else {
      setAccountName("");
      setEnvironment("");
      setAccountCreatedDate("");
      setShowCsp("");
      setSelectedValue("");
      setCurrentAction("add");
    }
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
  };
  useEffect(() => {
    const originalArray = getCSPListData;
    const newArray = originalArray.map((item) => ({
      label: item,
      value: item,
    }));
    setnewArray(newArray);

    const envArray = EnvironmentData;
    const ArrayEnv = envArray.map((item) => ({
      label: item,
      value: item,
    }));
    setEnvironmentData(ArrayEnv);
  }, [getAccountIdListData, getCSPListData, EnvironmentData]);
  const validateForm = () => {
    let formValidation = true;
    if (showCsp === "" || showCsp === null) {
      setState((state) => ({
        ...state,
        CSPError: true,
        CSPErrorMessage: "Cloud Service Provider should not be empty",
      }));
      formValidation = false;
    }
    if (selectedValue === null || selectedValue === "") {
      setState((state) => ({
        ...state,
        AccountIdError: true,
        AccountIdErrorMessage: "Account ID should not be empty",
      }));
      formValidation = false;
    }
    if (accountName === null || accountName.trim() === "") {
      setState((state) => ({
        ...state,
        AccountNameError: true,
        AccountNameErrorMessage: "Account Name should not be empty",
      }));
      formValidation = false;
    }
    if (environment === null || environment === "") {
      setState((state) => ({
        ...state,
        EnvironmentError: true,
        EnvironmentErrorMessage: "Environment should not be empty",
      }));
      formValidation = false;
    }
    if (
      AccountCreatedDate.trim() === "" ||
      AccountCreatedDate === null ||
      AccountCreatedDate[0].trim() === ""
    ) {
      setAccdateError(true);
      setAccdateErrorMessage("Account Created Date should not be empty");
      formValidation = false;
    }
    return formValidation;
  };
  const clearValidation = () => {
    setState((state) => ({
      ...state,
      AccountIdError: false,
      CSPError: false,
      CSPErrorMessage: "",
      AccountIdErrorMessage: "",
      EnvironmentError: false,
      EnvironmentErrorMessage: "",
      AccountNameError: false,
      AccountNameErrorMessage: "",
    }));
    setAccdateError(false);
    setAccdateErrorMessage("");
  };

  const handleSaveEdit = () => {
    const validation = validateForm();
    if (validation) {
      const payload = {
        accountId: selectedValue[0].value,
        accountName: accountName,
        environment: environment[0].value,
        accountCreatedDate: DateToEpochConverter(AccountCreatedDate),
        csp: showCsp[0].value,
        createBy: "",
        createdDt: "",
        id: Number(getId),
        updateBy: "",
        userCount: "",
        updateDt: "",
      };

      try {
        getCspSaveOrUpdate({ payloadid, userName, payload }).then((response) => {
          const res = response?.data || {};
          const { statusCodeValue, body } = res;

          if (statusCodeValue === 200) {
            addserverclose();
            getAccountInfo();
            callCommonAlert("success", body || "CSP created successfully");
            hideCommonAlert();
            setState((prev) => ({ ...prev, modalOpen: false }));
            dispatch(
              setIsOffCanvasOpen({
                isDrilldownOpen: false,
                isDropDownhide: false,
              })
            );
          } else if (statusCodeValue === 400) {
            getAccountInfo();
            callCommonAlert("error", body || "CSP Account already exists!");
            hideCommonAlert();
            setState((prev) => ({ ...prev, modalOpen: false }));
          } else {
            // Handle unexpected cases
            callCommonAlert("error", body || "Something went wrong!");
            hideCommonAlert();
          }
        });
      } catch (error) {
        callCommonAlert("error", "Something went wrong. Please try again.");
        hideCommonAlert();
        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
      }
    }
  };
  const submitSave = useCallback(async () => {
    if (currentAction === "edit") {
      handleSaveEdit();
    } else {
      handleSaveAdd();
    }
  });

  const addserverclose = async () => {
    dispatch(hideOffCanvas(false));
    addBodyCloseAccount();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };

  const modalBody = () => (
    <>
      <h4 className="delete-h">Delete Cloud Accounts</h4>
      {cloudDeleteLoad ? (
        <Spinners />
      ) : (
        <div>
          <p>Are you sure you would like to delete the Cloud Account?</p>
          <div className="btnswrap btn-dlt">
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              onClick={handleClose}
            />
            <ButtonComponent
              text="Delete"
              className={"btnStyle btn btn-primary"}
              onClick={deleteId}
            />
          </div>
        </div>
      )}
    </>
  );
  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
  };
  const addmodalCancelAccount = () => {
    setState((state) => ({
      ...state,
      addBodyAccount: true,
    }));
  };
  const addBodyCloseAccount = () => {
    setState({
      ...state,
      addBodyAccount: false,
    });
  };
  const addBodyCancelAccount = () => {
    return (
      <>
        <DiscardChanges
          title={"add"}
          discardClick={addserverclose}
          cancelClick={addBodyCloseAccount}
        />
      </>
    );
  };

  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
  }
  function getPage(pageNo) {
    setpageNo(pageNo);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
  }
  // const handleCSP = (e) => {
  //   setState((state) => ({
  //     ...state,
  //     "AccountIdError": false,
  //     "ServerError": false,
  //     "ServerErrorMessage": "",
  //     "ServerErrorMessage": "",
  //   }));
  //   setShowCsp(e.target.value);
  // };

  const handleAccountCreatedDate = (date) => {
    setAccountCreatedDate(date.target.value);
    setAccdateError(false);
    setState({
      ...state,
      conformationPop: true,
    });
  };
  const restrictDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  return (
    <>
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <CustomModal
          modalOpen={state.addBodyAccount}
          modalBody={addBodyCancelAccount}
          modalHide={addmodalCancelAccount}
          closeBtn={true}
          closeBtnFuc={addBodyCloseAccount}
        />
        <CustomModal
          modalOpen={state.InfoBody}
          modalBody={modalBodyInfo}
          modalHide={InfomodalCancelAccount}
          closeBtn={true}
          closeBtnFuc={InfomodalCancelAccount}
        />
        <EmptyDrillDownThree />
        <DrillDownOffCanvas
          customClass={"flowblock toolwrap custom_scroll"}
        // subHeading={"Please enter your Project data."}
        />
      </ProjectContext.Provider>
      <div className="mt-3 p-0-5">
        {/* <div className="btnwrap d-flex justify-content-end">
            <div>
              <input
                type="text"
                className="search_class "
                placeholder="Search"
              />
            </div>
            {showServerAddBtn && (
              <div>
                <button
                  className="solid-btn mr-5"
                  onClick={() => openserver("add", 0)}
                >
                  Add New
                </button>
              </div>
            )}
          </div> */}
        <div className="row">
          <div>
            <div className="grid-table">
              {/* {cloudAccountListLoading && cloudAccountCountLoading ? (
                <Spinners />
              ) : ( */}
              <>
                <CompleteTableData
                  isLoading={cloudAccountListLoading}
                  data={
                    cloudAccountListData?.data
                      ? cloudAccountListData?.data
                      : []
                  }
                  columns={columns}
                  onPageLimitChange={getLimit}
                  onPageNoChange={getPage}
                  onSearch={getSearchKey}
                  curentPageNumber={pageNo}
                  pageLimit={pageLimit}
                  searchKey={searchKey}
                  totalPageCount={finalPageCount}
                  listCount={cloudAccountListData?.totalCount}
                  btnData={btnData}
                  moveSearchToEnd={true}
                />
              </>
              {/* )} */}
            </div>
          </div>
          <div className={"formCol dashcol filtercol bg-white p-0"}>
            <CustomOffCanvas className="custom-off-canvas">
              <h3
                className="flowhead"
                id="updatehead"
                style={{ display: "block" }}
              >
                {currentAction === "edit"
                  ? "Update CSP Account"
                  : "Map New Account"}{" "}
              </h3>
              <Row className="appConfigAddNew m-0">
                <Col>
                  <div className="mb-3">
                    {/* <label className="form-label">Cloud Service Provider</label> */}
                    {/* <input
                      type="text"
                      list="serverlistdatalist"
                      name={"server"}
                      id="server"
                      className="form-control"
                      placeholder="Enter Cloud Service Provider"
                      value={showCsp}
                      onChange={(e) => setShowCsp(e.target.value)}
                      maxLength="50"

                    /> */}
                    {/* <Input
                      label={"Cloud Service Provider"}
                      name={"server"}
                      type="text"
                      id={"server"}
                      containerClassName={"frmgroup validate default-input"}
                      options={search}
                      onChange={handleCSP}
                      //value={state.name}
                      placeholder="Enter Cloud Service Provide"
                      autoComplete={"off"}
                      maxLength={"50"}
                      error={state["ServerError"]}
                      errorMessage={state["ServerErrorMessage"]}
                      onkeypress={true}
                    /> */}
                    <CustomSelectDropDown
                      id={"CSP"}
                      labelName={"Cloud Service Provider*"}
                      name={"CSP"}
                      className="accountId"
                      options={newArray}
                      onSearch={(searchString) =>
                        handleSearch("CSP", searchString, newArray)
                      }
                      handleInputChange={(e) => handleCSPInputChange(e)}
                      containerClassName={"frmgroup validate default-input"}
                      selected={newArray}
                      value={showCsp}
                      onChange={(selected) => handleOnChange("CSP", selected)}
                      placeholder={"Enter Cloud Service Provider"}
                      error={state["CSPError"]}
                      errorMessage={state["CSPErrorMessage"]}
                      isDisabled={currentAction === "edit"}
                    />
                    {/* <ServerListDataList /> */}
                  </div>
                </Col>
                <Col>
                  <div className="frmgroup default-input">
                    {/* <label className="form-label">Account ID</label> */}
                    <CustomSelectDropDown
                      id="AccountId"
                      name={"Account ID"}
                      labelName={"Account ID*"}
                      className="accountId"
                      options={state.cspListData}
                      onSearch={(searchString) =>
                        handleSearch(
                          "AccountId",
                          searchString,
                          state.cspListData
                        )
                      }
                      value={selectedValue}
                      handleInputChange={(e) => handleAccountInputChange(e)}
                      containerClassName={"frmgroup validate default-input"}
                      selected={state.cspListData}
                      onChange={(selected) =>
                        handleOnChange("AccountId", selected)
                      }
                      placeholder={"Enter Account ID"}
                      error={state["AccountIdError"]}
                      errorMessage={state["AccountIdErrorMessage"]}
                      isDisabled={currentAction === "edit"}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="m-0">
                <Col>
                  <Input
                    type="text"
                    label="Account Name*"
                    name="AccountName"
                    id="AccountName"
                    error={state.AccountNameError}
                    errorMessage={state.AccountNameErrorMessage}
                    list="serverlistdatalist"
                    placeholder="Enter Account Name"
                    autoComplete={"off"}
                    onChange={(e) =>
                      handleOnChange("AccountName", e.target.value.trimStart())
                    }
                    onKeyPress={(e) => {
                      // Prevent space as the first character
                      if (e.target.value === "" && e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    containerClassName={"frmgroup validate default-input"}
                    value={accountName}
                    maxLength="60"
                  />
                </Col>
                <Col>
                  <CustomSelectDropDown
                    id="Environment"
                    labelName={"Environment*"}
                    name={"Environment"}
                    className="environment"
                    options={environmentData}
                    onSearch={(searchString) =>
                      handleSearch("Environment", searchString, environmentData)
                    }
                    handleInputChange={(e) => handleAccountInputChange(e)}
                    containerClassName={"frmgroup validate default-input"}
                    selected={environmentData}
                    onChange={(selected) =>
                      handleOnChange("Environment", selected)
                    }
                    placeholder={"Enter Environment"}
                    error={state["EnvironmentError"]}
                    value={environment}
                    errorMessage={state["EnvironmentErrorMessage"]}
                    noOptionSorting={true}
                    isDisabled={currentAction === "edit"}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input
                    containerClassName="AccountcreatedInput"
                    type={"date"}
                    name={"Account Created Date"}
                    id={"AccountCreatedDate"}
                    label={"Account Created Date*"}
                    value={AccountCreatedDate}
                    error={accdateError}
                    errorMessage={accdateErrorMessage}
                    onChange={handleAccountCreatedDate}
                    maxlength="50"
                    maxDate={restrictDate()}
                    placeholder={"Enter Account Created Date"}
                    autoComplete={"off"}
                    inputClassName={"form-control"}
                    disabled={currentAction === "edit"}
                  />
                </Col>
                <Col></Col>
              </Row>
              {/* <div className="mb-3">
              <label for="ip" className="form-label">Account Name</label>
              <input type="text" list="serverlistdatalist" name={"host"} id="host" className="form-control" placeholder="Enter the Account Name" value={showAccountName} onChange={e => setShowAccountName(e.target.value)} maxlength="50" />
              
            </div> */}
              <div className="custom-select-server">
                <input
                  type="hidden"
                  name={"id"}
                  id="id"
                  className="form-control"
                  placeholder="id"
                  value={getId}
                  onChange={(e) => setGetId(e.target.value)}
                />
              </div>
              <Row>
                <Col></Col>
                <Col>
                  <div
                    className="server-btn"
                    style={{
                      display: "block",
                      justifyContent: "end",
                    }}
                  >
                    <ButtonComponent
                      text="Cancel"
                      className="cancelBtnStyle"
                      onClick={() => {
                        if (state.conformationPop) {
                          addmodalCancelAccount();
                        } else {
                          addserverclose();
                        }
                      }}
                    />

                    {/* {currentAction === "edit" ? ' ' : <button className="solid-btn svebusiness" onClick={() => resetInput()}>Reset</button>} */}
                    {/* <button className="solid-btn" onClick={() => submitSave()} disabled={isDisabled()}>Submit</button> */}
                    {/* <Button
                variant="primary"
                size="sm"
                className="solid-btn px-4"
                onClick={() => submitSave()}
                disabled={isDisabled()}
              >
                {" "}
                {currentAction === "edit" ? " Save " : " Save "}
              </Button>{" "} */}
                    {/* {!showCsp || selectedValue === null ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip>Please fill all the above fields</Tooltip>
                    }
                  >
                    <ButtonComponent
                      text="Save"
                      onClick={submitSave}
                      disabled={isDisabled}
                    />
                  </OverlayTrigger>
                ) : ( */}
                    <ButtonComponent text="Save" onClick={submitSave} />
                    {/* )} */}
                  </div>
                </Col>
              </Row>
            </CustomOffCanvas>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountIds;

AccountIds.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
  value: PropTypes.any.isRequired,
};
